import { render, staticRenderFns } from "./addRoleDialog.vue?vue&type=template&id=71da470a&scoped=true"
import script from "./addRoleDialog.vue?vue&type=script&lang=js"
export * from "./addRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71da470a",
  null
  
)

export default component.exports